<template>
  <!-- Desktop view -->
  <div class="container-lg hide-md mb-[3rem]" v-if="allBannersExist">
    <div class="row">
      <div class="col-md-7">
        <a :href="product_banner_one.link"
           :style="{backgroundImage: `url(${product_banner_one.image.webp}), url(${product_banner_one.image.source})`}"
           class="extra extra--gray extra--h100p extra--lg extra--column"
           :title="product_banner_one.title"
        >
        </a>
      </div>
      <div class="col-md-5">
        <a :href="product_banner_two.link"
           :style="{backgroundImage: `url(${product_banner_two.image.webp}), url(${product_banner_two.image.source})`}"
           class="extra extra--orange extra--md mb-4"
           :title="product_banner_two.title"
        />
        <a :href="product_banner_three.link"
           :style="{backgroundImage: `url(${product_banner_three.image.webp}), url(${product_banner_three.image.source})`}"
           class="extra extra--gray extra--md"
           :title="product_banner_three.title"
        />
      </div>
    </div>
  </div>

  <!-- Mobile Extra Slider -->
  <div class="container-lg hide show-md" v-if="allBannersExist">
    <div id="extraSlider" class="extra-slider" data-extra-slider>
      <div class="slider-item">
        <div
            :style="{backgroundImage: `url(${product_banner_one.image.webp}), url(${product_banner_one.image.source})`}"
            class="extra extra--gray extra--h100p extra--lg extra--column"
        >
        </div>
      </div>
      <div class="slider-item">
        <a :href="product_banner_two.link"
           :style="{backgroundImage: `url(${product_banner_two.image.webp}), url(${product_banner_two.image.source})`}"
           class="extra extra--orange extra--md"
           :title="product_banner_two.title"
        >
        </a>
      </div>
      <div class="slider-item">
        <a :href="product_banner_three.link"
           :style="{backgroundImage: `url(${product_banner_three.image.webp}), url(${product_banner_three.image.source})`}"
           class="extra extra--gray extra--md"
           :title="product_banner_three.title"
        >
        </a>
      </div>
    </div>

    <div class="slider-arrows slider-arrows--center">
      <button class="slider__arrows-prev" data-slick-arrows-for="#extraSlider" type="button">Prev</button>
      <button class="slider__arrows-next" data-slick-arrows-for="#extraSlider" type="button">Next</button>
    </div>
  </div>
</template>

<script>

export default {
  name:  "ProductExtras",
  props: [
    'product_banner_one',
    'product_banner_two',
    'product_banner_three'
  ],

  computed: {
    allBannersExist() {
      return this.product_banner_one && this.product_banner_two && this.product_banner_three;
    }
  },

  methods: { },
}
</script>

<style scoped>
.extra {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}
</style>